import { useEffect } from 'react'

import { useLogout } from 'src/contexts/AuthContext'

/**
 * Standalone logout page that can be reached by external apps (e.g. Control).
 *
 * Clears session cookies (SID, RMSID, BEARER) and triggers Auth0's logout
 * flow which destroys the Auth0 session server-side before redirecting to
 * the login page.
 *
 * This component lives outside AuthContextProvider (rendered via
 * UserlessRoutes) so it works even when the user has no active session
 * in the React app. The useLogout hook only depends on Auth0Provider
 * context, which wraps both AuthContextProvider and UserlessRoutes.
 */
const Logout: React.FC = () => {
  const handleLogout = useLogout()

  useEffect(() => {
    handleLogout()
  }, [handleLogout])

  return null
}

export default Logout
